import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://sistemafinanciero.digitaleseduproperu.com/api';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const TIPOS = [
  { value: 'gratificacion',     label: 'Gratificación' },
  { value: 'cts',               label: 'CTS' },
  { value: 'vacaciones',        label: 'Vacaciones' },
  { value: 'bono',              label: 'Bono' },
  { value: 'asignacion_familiar', label: 'Asignación Familiar' },
  { value: 'movilidad',         label: 'Movilidad' },
  { value: 'alimentacion',      label: 'Alimentación' },
  { value: 'otro',              label: 'Otro' },
];

const EMPTY = {
  empleado_id: '', tipo: '', descripcion: '',
  monto: '', fecha: new Date().toISOString().substring(0, 10),
  mes: new Date().getMonth() + 1,
  anio: new Date().getFullYear(),
  observacion: '',
};

export default function BeneficiosPage() {
  const [vista, setVista]         = useState('lista');
  const [empleados, setEmpleados] = useState([]);
  const [beneficios, setBeneficios] = useState([]);
  const [resumen, setResumen]     = useState([]);
  const [anio, setAnio]           = useState(new Date().getFullYear());
  const [filtroTipo, setFiltroTipo]     = useState('');
  const [filtroEstado, setFiltroEstado] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [form, setForm]           = useState(EMPTY);
  const [editId, setEditId]       = useState(null);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);

  useEffect(() => { cargarEmpleados(); }, []);
  useEffect(() => { if (vista === 'lista') cargarBeneficios(); }, [vista, filtroTipo, filtroEstado, anio]);
  useEffect(() => { if (vista === 'resumen') cargarResumen(); }, [vista, anio]);

  const cargarEmpleados = async () => {
    try {
      const res = await axios.get(`${API}/empleados`, {
        headers: headers(), params: { estado: 'activo' }
      });
      setEmpleados(res.data);
    } catch (e) { console.error(e); }
  };

  const cargarBeneficios = async () => {
    try {
      const params = { anio };
      if (filtroTipo) params.tipo = filtroTipo;
      if (filtroEstado) params.estado = filtroEstado;
      const res = await axios.get(`${API}/beneficios`, { headers: headers(), params });
      setBeneficios(res.data);
    } catch (e) { console.error(e); }
  };

  const cargarResumen = async () => {
    try {
      const res = await axios.get(`${API}/beneficios/resumen`, {
        headers: headers(), params: { anio }
      });
      setResumen(res.data);
    } catch (e) { console.error(e); }
  };

  const abrirNuevo = () => {
    setForm(EMPTY); setEditId(null); setError(''); setShowModal(true);
  };

  const abrirEditar = (b) => {
    setForm({
      empleado_id:  b.empleado_id,
      tipo:         b.tipo,
      descripcion:  b.descripcion || '',
      monto:        b.monto,
      fecha:        b.fecha?.substring(0, 10),
      mes:          b.mes || '',
      anio:         b.anio || new Date().getFullYear(),
      observacion:  b.observacion || '',
    });
    setEditId(b.id); setError(''); setShowModal(true);
  };

  const guardar = async () => {
    if (!form.empleado_id || !form.tipo || !form.monto || !form.fecha) {
      setError('Complete los campos obligatorios.'); return;
    }
    setLoading(true);
    try {
      if (editId) {
        await axios.put(`${API}/beneficios/${editId}`, form, { headers: headers() });
      } else {
        await axios.post(`${API}/beneficios`, form, { headers: headers() });
      }
      setShowModal(false); cargarBeneficios();
    } catch (e) {
      setError(e.response?.data?.message || 'Error al guardar.');
    } finally { setLoading(false); }
  };

  const marcarPagado = async (id) => {
    if (!window.confirm('¿Marcar como pagado?')) return;
    try {
      await axios.patch(`${API}/beneficios/${id}/pagado`, {}, { headers: headers() });
      cargarBeneficios();
    } catch (e) { console.error(e); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este beneficio?')) return;
    try {
      await axios.delete(`${API}/beneficios/${id}`, { headers: headers() });
      cargarBeneficios();
    } catch (e) { console.error(e); }
  };

  const tipoLabel = (tipo) => TIPOS.find(t => t.value === tipo)?.label || tipo;

  const fmt = (v) => `S/ ${parseFloat(v || 0).toFixed(2)}`;

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold mb-0">
          <i className="fas fa-gift me-2 text-primary"></i>Beneficios
        </h2>
        <div className="d-flex gap-2">
          <div className="btn-group">
            <button className={`btn ${vista==='lista'?'btn-primary':'btn-outline-primary'}`}
              onClick={() => setVista('lista')}>
              <i className="fas fa-list me-1"></i>Lista
            </button>
            <button className={`btn ${vista==='resumen'?'btn-primary':'btn-outline-primary'}`}
              onClick={() => setVista('resumen')}>
              <i className="fas fa-chart-bar me-1"></i>Resumen
            </button>
          </div>
          <button className="btn btn-success" onClick={abrirNuevo}>
            <i className="fas fa-plus me-1"></i>Nuevo Beneficio
          </button>
        </div>
      </div>

      {/* Filtros */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-3">
              <label className="form-label">Año</label>
              <input type="number" className="form-control" value={anio}
                onChange={e => setAnio(parseInt(e.target.value))} />
            </div>
            {vista === 'lista' && (
              <>
                <div className="col-md-3">
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={filtroTipo}
                    onChange={e => setFiltroTipo(e.target.value)}>
                    <option value="">Todos</option>
                    {TIPOS.map(t => (
                      <option key={t.value} value={t.value}>{t.label}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Estado</label>
                  <select className="form-select" value={filtroEstado}
                    onChange={e => setFiltroEstado(e.target.value)}>
                    <option value="">Todos</option>
                    <option value="pendiente">Pendiente</option>
                    <option value="pagado">Pagado</option>
                  </select>
                </div>
                <div className="col-md-3 d-flex align-items-end">
                  <span className="text-muted">{beneficios.length} registro(s)</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* LISTA */}
      {vista === 'lista' && (
        <div className="card">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Empleado</th>
                    <th>Tipo</th>
                    <th>Descripción</th>
                    <th>Fecha</th>
                    <th className="text-end">Monto</th>
                    <th className="text-center">Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {beneficios.length === 0
                    ? <tr><td colSpan={7} className="text-center py-4 text-muted">
                        No hay beneficios registrados.
                      </td></tr>
                    : beneficios.map(b => (
                      <tr key={b.id}>
                        <td>
                          <div className="fw-semibold">{b.empleado_nombre}</div>
                          <small className="text-muted">{b.cargo}</small>
                        </td>
                        <td>
                          <span className="badge bg-primary bg-opacity-10 text-primary border border-primary">
                            {tipoLabel(b.tipo)}
                          </span>
                        </td>
                        <td><small>{b.descripcion || '—'}</small></td>
                        <td>{b.fecha?.substring(0, 10)}</td>
                        <td className="text-end fw-bold text-success">{fmt(b.monto)}</td>
                        <td className="text-center">
                          <span className={`badge ${b.estado === 'pagado' ? 'bg-success' : 'bg-warning text-dark'}`}>
                            {b.estado}
                          </span>
                        </td>
                        <td>
                          <div className="d-flex gap-1">
                            <button className="btn btn-sm btn-outline-primary"
                              onClick={() => abrirEditar(b)} title="Editar">
                              <i className="fas fa-edit"></i>
                            </button>
                            {b.estado === 'pendiente' && (
                              <button className="btn btn-sm btn-outline-success"
                                onClick={() => marcarPagado(b.id)} title="Marcar pagado">
                                <i className="fas fa-check"></i>
                              </button>
                            )}
                            <button className="btn btn-sm btn-outline-danger"
                              onClick={() => eliminar(b.id)} title="Eliminar">
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* RESUMEN */}
      {vista === 'resumen' && (
        <div className="card">
          <div className="card-header">
            <h5 className="mb-0">Resumen de Beneficios {anio}</h5>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Empleado</th>
                    <th>Cargo</th>
                    <th className="text-end">Gratificación</th>
                    <th className="text-end">CTS</th>
                    <th className="text-end">Vacaciones</th>
                    <th className="text-end">Bonos</th>
                    <th className="text-end fw-bold">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {resumen.length === 0
                    ? <tr><td colSpan={7} className="text-center py-4 text-muted">
                        No hay datos para este año.
                      </td></tr>
                    : resumen.map(r => (
                      <tr key={r.empleado_id}>
                        <td className="fw-semibold">{r.empleado_nombre}</td>
                        <td><small className="text-muted">{r.cargo}</small></td>
                        <td className="text-end">{fmt(r.gratificacion)}</td>
                        <td className="text-end">{fmt(r.cts)}</td>
                        <td className="text-end">{fmt(r.vacaciones)}</td>
                        <td className="text-end">{fmt(r.bono)}</td>
                        <td className="text-end fw-bold text-success">{fmt(r.total_beneficios)}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{background:'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editId ? 'Editar Beneficio' : 'Nuevo Beneficio'}
                </h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">Empleado *</label>
                    <select className="form-select" value={form.empleado_id}
                      onChange={e => setForm(f => ({...f, empleado_id: e.target.value}))}>
                      <option value="">Seleccionar empleado</option>
                      {empleados.map(e => (
                        <option key={e.id} value={e.id}>
                          {e.apellidos}, {e.nombres} — {e.cargo}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tipo *</label>
                    <select className="form-select" value={form.tipo}
                      onChange={e => setForm(f => ({...f, tipo: e.target.value}))}>
                      <option value="">Seleccionar</option>
                      {TIPOS.map(t => (
                        <option key={t.value} value={t.value}>{t.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Monto (S/) *</label>
                    <input type="number" className="form-control" step="0.01"
                      value={form.monto}
                      onChange={e => setForm(f => ({...f, monto: e.target.value}))} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Fecha *</label>
                    <input type="date" className="form-control" value={form.fecha}
                      onChange={e => setForm(f => ({...f, fecha: e.target.value}))} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Mes</label>
                    <input type="number" className="form-control" min="1" max="12"
                      value={form.mes}
                      onChange={e => setForm(f => ({...f, mes: e.target.value}))} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Año</label>
                    <input type="number" className="form-control"
                      value={form.anio}
                      onChange={e => setForm(f => ({...f, anio: e.target.value}))} />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Descripción</label>
                    <input className="form-control" value={form.descripcion}
                      onChange={e => setForm(f => ({...f, descripcion: e.target.value}))} />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Observación</label>
                    <textarea className="form-control" rows={2} value={form.observacion}
                      onChange={e => setForm(f => ({...f, observacion: e.target.value}))} />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
                <button className="btn btn-primary" onClick={guardar} disabled={loading}>
                  {loading ? 'Guardando...' : (editId ? 'Actualizar' : 'Registrar')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}